<template>
  <div class="mobile_container">
    <div class="mobile_banner" @click="console">
      <div id="video">
        <li v-for="camera in deviceCameraList" :class="{disable:camera.Id != curCameraId}">
          <video :id="camera.HLSUrl" poster="" controls playsInline webkit-playsinline autoplay>
            <!--<source src="rtmp://rtmp.open.ys7.com/openlive/aeea5b2c05e64b2097a9039bdcf60aba.hd" type="" />-->
            <!--<source src="http://hls.open.ys7.com/openlive/aeea5b2c05e64b2097a9039bdcf60aba.m3u8" type="application/x-mpegURL" />-->
            <!--<source :src="camera.RTMPUrl" type=""/>-->
            <source :src="camera.HLSUrl" type="application/x-mpegURL"/>
          </video>
        </li>
      </div>
      <div class="videoSelect">
        <p v-for="item in deviceCameraList" @click="videoSwitch(item.Id)" :class="{active:item.Id == curCameraId}">
          {{item.Name}}
        </p>
      </div>
    </div>

    <div class="content">
      <ul class="menu">
        <span class="triangle" :class="{showSensor:showSensor,showController:!showSensor}"></span>
        <li @click="tab(0)" v-bind:class="{active:showSensor}">传感器</li>
        <li @click="tab(1)" v-bind:class="{active:!showSensor}">控制器</li>
      </ul>

      <div class="sensorArea" v-if="showSensor">
        <ul>
          <li v-for="item in deviceSensorList" @click="sensorHistory(item.Id)">
            <p>
              <img src="../../assets/img/m/mark.png" alt="">
              {{item.Name}}
            </p>
            <p>
              {{item.CurrentValue}}
              <span>{{item.Unit}}</span>
            </p>
            <p>{{item.CurrentTime}}</p>
          </li>

          <!--
          <li>
            <p>
              <img src="../../assets/img/m/mark.png" alt="">
              温度计
            </p>
            <p>
              35.5
              <span>℃</span>
            </p>
            <p>2018-07-12 18:04:24</p>
          </li>
          <li>
            <p>
              <img src="../../assets/img/m/mark.png" alt="">
              湿度计
            </p>
            <p>
              74.5
              <span>％</span>
            </p>
            <p>2018-07-12 18:04:24</p>
          </li>
          <li>
            <p>
              <img src="../../assets/img/m/mark.png" alt="">
              土壤湿度
            </p>
            <p>
              30.6
              <span>％</span>
            </p>
            <p>2018-07-12 18:04:24</p>
          </li>
          -->
        </ul>
      </div>
      <div class="controller" v-else>
        <ul>
          <li v-for="controller in deviceControllerList">
            <p class="fl">
              <img class="mark" src="../../assets/img/m/mark.png" alt="">
              <span>{{controller.Name}}</span>
            </p>
            <p class="fr">
              <mt-switch class="switch" v-model="value"></mt-switch>
              <i class="icon iconfont1 icon1-tubiao" @click="controllerHistory(controller.Id)"></i>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config.js'
  import '@/assets/css/icon-iot-mobile/iconfont.css'
  import lib from "@/assets/js/lib/index.js"

  export default {
    name: 'groupDetail',
    components: {},
    data() {
      return {
        baseUrl: config("baseServerUrl", "."),
        curCameraId: 0,
        value: true,
        showSensor: true,
        GroupId: 0,
        GroupName: "",
        deviceSensorAllList: [],
        deviceSensorList: [],
        deviceSensorAllObj: {},
        deviceControllerAllList: [],
        deviceControllerList: [],
        deviceCameraAllList: [],
        deviceCameraList: [],
      }
    },
    mounted: function () {

    },
    created() {
      this.GroupId = this.$route.query.GroupId
      this.GroupName = this.$route.query.GroupName

			var token = this.$route.query.token
			var username = this.$route.query.username

			if(lib.isset(token) && lib.isset(username) && token.length > 0 && username.length > 0) {
				this.$store.dispatch('UserLogin', token)
      	this.$store.dispatch('UserName', username)
			}

			// wx.miniProgram.navigateTo({url: '../iot/index'})

      this.getDevice()
    },
    watch: {
      curCameraId: function (n, o) {
        //n变化之后的新数据
        //o变化之前的旧数据
        console.log('n', n)
        if(o != 0) {//非初次改变数据才做动作
          this.pauseVideo(o)
          this.playVideo(n)
        }
      },
    },
    methods: {
      console() {
        console.log('deviceCameraList', this.deviceCameraList)
        console.log('curCameraId', this.curCameraId)
      },
      playVideo(Id) {
        var _this = this
        setTimeout(function () {
          console.log('playOne')
          console.log('this.deviceCameraList',_this.deviceCameraList)
          var domId
          for (var i = 0; i < _this.deviceCameraList.length; i++) {
            if (_this.deviceCameraList[i].Id == Id) {
              domId = _this.deviceCameraList[i].HLSUrl
            }
          }
          console.log('playId', domId)
          var player = new EZUIPlayer(domId)
          //player.play()
          player.on('error', function () {
            console.log('error');
          });
          player.on('play', function () {
            console.log('play');
          });
          player.on('pause', function () {
            console.log('pause');
          });
        },1000)
      },
      pauseVideo(Id) {
        var domId
        for (var i = 0; i < this.deviceCameraList.length; i++) {
          if (this.deviceCameraList[i].Id == Id) {
            domId = this.deviceCameraList[i].HLSUrl
          }
        }
        var player = new EZUIPlayer(domId)
        player.pause()
      },
      videoSwitch(Id) {
        this.curCameraId = Id
        console.log('videoSwitch',this.curCameraId)
      },
      tab(index) {
        if (index == 0) {
          this.showSensor = true
        } else {
          this.showSensor = false
        }
      },
      getDevice() {
        var url = this.baseUrl + 'api/devicesensor/getallbyuser?groupid=' + this.GroupId
        this.$http.get(url, {}).then(res => {
          this.deviceSensorAllList = res.data.Data || []
          this.getDeviceSensorAllList()
        }).catch(error => {
          this.$Message.error('查询传感器列表数据失败，' + error.message)
        })

        var url = this.baseUrl + 'api/devicecontroller/getallbyuser?groupid=' + this.GroupId
        this.$http.get(url, {}).then(res => {
          this.deviceControllerAllList = res.data.Data || []
          this.deviceControllerList = this.deviceControllerAllList[0].Controllers
          this.getDeviceControllerByGroup()
        }).catch(error => {
          this.$Message.error('查询控制器列表数据失败，' + error.message)
        })

        this.getDeviceCameraAllList()
      },
      getDeviceSensorAllList() {
        let item
        for (var index in this.deviceSensorAllList) {
          item = this.deviceSensorAllList[index]
          if (item.Sensors.length == 0) continue
          if (item.GroupId == this.GroupId) {
            this.deviceSensorList = item.Sensors
          }

          item = item.Sensors
          for (var i = 0, len = item.length; i < len; i++) {
            this.deviceSensorAllObj[item[i].Id] = item[i]
          }
        }

        this.getDeviceSensorListByGroup()
      },
      getDeviceSensorListByGroup() {
        let url = this.baseUrl + 'api/devicesensor/getvaluebygroup?id=' + this.GroupId
        this.loading = true
        this.$http.get(url, {}).then(res => {
          this.loading = false
          let data = res.data.Data || []
          let Id
          let Icon
          let IconColor
          let IconSize
          var test = []
          let sensorClass = []
          let patrnRightBorder = /^[0-9]*[01235678]$/ //右边框
          // let patrnRightBorder = /^[0-9]*[0123456789]$/ //右边框
          let patrnBottomBorder = /^[0-9]*[0123456789]$/  //下边框
          for (var index in data) {
            Id = data[index].Id

            //时间处理
            var sensorTime = data[index].CurrentTime
            var timeArr1 = sensorTime.split('T')
            var timeArr2 = timeArr1[1].split('.')
            data[index].CurrentTime = timeArr1[0] + ' ' + timeArr2[0]

            Icon = null
            IconColor = null
            IconSize = null
            switch (this.deviceSensorAllObj[Id].Type) {
              case '温度':
                Icon = "icon-wendu"
                IconColor = '#5F96D4'
                break
              case '湿度':
                Icon = "icon-kongqishidu"
                IconColor = '#51b8f2'
                break
              case '土壤湿度':
                Icon = "icon-turangshidu"
                IconColor = '#7BD09A'
                break
              case '空气湿度':
                Icon = "icon-kongqishidu"
                IconColor = '#51b8f2'
                break
              case '光照':
                Icon = "icon-guangzhao"
                IconColor = '#f4ea2a'
                break
              case 'EC':
                Icon = "icon-EC"
                IconColor = '#afcd50'
                IconSize = '40px'
                break
              case 'PH':
                Icon = "icon-suanjiandu"
                IconColor = '#36ab60'
                break
              case '钾元素':
                Icon = "icon-jiayuansu"
                IconColor = '#83c6c2'
                break
              case '磷元素':
                Icon = "icon-linyuansu"
                IconColor = '#db639b'
                break
              case '氮元素':
                Icon = "icon-danyuansu"
                IconColor = '#efb336'
                break
              case '硫化氢':
                Icon = "icon-liuhuaqing"
                IconColor = '#8cbb19'
                break
              case '溶解氧':
                Icon = "icon-rongjieyang"
                IconColor = '#aF96D4'
                break
              case '外遮阳':
                Icon = "icon-waizheyang"
                IconColor = '#fBD09A'
                break
              case '土壤温度':
                Icon = "icon-turangwendu"
                IconColor = '#804f4c'
                break
              case '二氧化硫':
                Icon = "icon-eryanghualiu"
                IconColor = '#d3217b'
                break
              case '一氧化碳':
                Icon = "icon-yiyanghuatan"
                IconColor = '#17abe3'
                break
              default:
                Icon = "icon-qita"
                IconColor = 'white'
                IconSize = '18px'
            }

            let sensorStyle = {}

            var NormalRange = this.deviceSensorAllObj[Id].NormalDataRange
            console.log('range', NormalRange)
            if (!lib.empty(NormalRange)) {
              var range = NormalRange.split('|')
              if (data[index].CurrentValue < range[0] || data[index].CurrentValue > range[1]) {
                sensorStyle.background = 'linear-gradient(180deg, rgba(252, 24, 99, 1) 0%, rgba(252, 24, 99, 1) 32%, rgba(253, 125, 78, 1) 100%, rgba(253, 125, 78, 1) 100%)'
              }
            }

            if (typeof this.deviceSensorAllObj[Id] == 'undefined') continue
            data[index].Name = this.deviceSensorAllObj[Id].Name
            data[index].Icon = Icon
            data[index].Unit = this.deviceSensorAllObj[Id].Unit
            data[index].Type = this.deviceSensorAllObj[Id].Type
            //data[index].sensorClass = sensorClass
            data[index].sensorStyle = sensorStyle
            data[index].IconColor = IconColor
            data[index].IconSize = IconSize

            //缺值处理
            if (data[index].CurrentValue == -99999) {
              data[index].CurrentValue = '暂无数据'
              data[index].Unit = ''
              data[index].EmpDataClass = true
            }
          }

          //排序
          var tempObj = {}
          for (var i = 0; i < data.length; i++) {
            tempObj[data[i].Id] = data[i]
          }

          var item
          var sensorList = []
          for (var index in this.deviceSensorAllList) {
            item = this.deviceSensorAllList[index]
            if (item.GroupId == this.GroupId) {
              sensorList = item.Sensors
            }
          }
          for (var j = 0; j < sensorList.length; j++) {
            sensorList[j] = tempObj[sensorList[j].Id]
          }

          console.log('sensorlist', sensorList)
          this.deviceSensorList = []
          this.deviceSensorList = sensorList
        }).catch(error => {
          //this.loading = false,
          this.$Message.error('查询传感器数据失败，' + error.message)
        })
      },
      getDeviceControllerByGroup() {
        var url = this.baseUrl + 'api/devicecontroller/getvaluebygroup?id=' + this.GroupId
        this.$http.get(url, {}).then(res => {

        }).catch(error => {
          this.$Message.error('查询控制器列表数据失败,' + error.message)
        })
      },
      getDeviceCameraAllList() {
        let url = this.baseUrl + 'api/Camera/getallbyuser?groupid=' + this.GroupId
        this.$http.get(url, {}).then(res => {
          this.deviceCameraAllList = res.data.Data || []
          this.deviceCameraList = this.deviceCameraAllList[0].Cameras

          this.curCameraId = this.deviceCameraList[0].Id
          this.playVideo(this.curCameraId)
        }).catch(error => {
          console.log('video-error', error)
          this.$Message.error('查询视频设备列表数据失败,' + error.message)
        })
      },
      sensorHistory(Id) {
        this.$router.push({
          path: 'sensorHistory',
          query: {Id: Id}
        })
      },
      controllerHistory(Id) {
        this.$router.push({
          path: 'controllerHistory',
          query: {Id: Id}
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .mobile_container {
    background: #F3F7F8;
    .mobile_banner {
      width: 100%;
      div#video {
        li {
          width: 100%;
          height: 4.24rem;
          display: block;
          &.disable {
            display: none;
          }
          video {
            width: 100%;
            height: 4.24rem;
          }
        }
      }
      div.videoSelect {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        border-bottom: solid 0.02rem rgba(228, 228, 228, 1);
        p {
          margin: 0.18rem 0.16rem;
          padding: 0.2rem 0.1rem;
          border-radius: 0.1rem;
          font-family: '微软雅黑';
          font-weight: 700;
          font-style: normal;
          font-size: 0.26rem;
          border: solid 0.02rem rgba(228, 228, 228, 1);
          color: rgba(0, 0, 0, 0.447058823529412);
          &.active {
            border: solid 0.02rem #009CCD;
            color: #009CCD;
          }
        }
      }
    }
    div.content {
      margin-bottom: 0.16rem;
      ul.menu {
        position: relative;
        width: 100%;
        padding: 0.2rem 0.3rem;
        overflow: hidden;
        margin-top: 0.2rem;
        background: rgba(46, 63, 89, 1);
        font-family: '微软雅黑';
        font-weight: 400;
        font-style: normal;
        font-size: 0.28rem;
        color: rgba(255, 255, 255, 0.447058823529412);
        text-align: center;
        li {
          width: 50%;
          float: left;
          &.active {
            font-weight: 700;
            color: #FFFFFF;
          }
        }
        span.triangle {
          position: absolute;
          display: inline-block;
          width: 0;
          height: 0;
          border-width: 0 30px 40px;
          border-style: solid;
          border-color: transparent transparent #F3F7F8; /*透明 透明  灰*/
          margin: 40px auto;
          &.showSensor {
            top: -0.16rem;
            left: 1.40rem;
          }
          &.showController {
            top: -0.16rem;
            left: 4.9rem;
          }
        }
      }
      div.sensorArea {
        ul {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          margin-top: 0.1rem;
          li {
            width: 3.52rem;
            margin: 0.1rem 0.1rem 0;
            border: solid 1px rgba(228, 228, 228, 1);
            p {
              font-family: '微软雅黑';
              font-weight: 400;
              font-style: normal;
              text-align: center;
              &:nth-child(1) {
                position: relative;
                font-size: 0.24rem;
                color: rgba(0, 0, 0, 0.847058823529412);
                padding: 0.15rem 0rem;
                img {
                  width: 0.56rem;
                  position: absolute;
                  left: 0;
                  top: 0.08rem;
                }
              }
              &:nth-child(2) {
                font-size: 0.52rem;
                color: rgba(30, 30, 30, 0.847058823529412);
                span {
                  font-size: 0.2rem;
                  color: rgba(30, 30, 30, 0.847058823529412);
                  position: relative;
                  top: -0.25rem;
                }
              }
              &:nth-child(3) {
                font-size: 0.2rem;
                color: rgba(0, 0, 0, 0.447058823529412);
                padding: 0.1rem 0;
              }
            }
          }
        }
      }
      div.controller {
        margin-top: 0.2rem;
        ul {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          li {
            width: 90%;
            margin: 0.2rem 0;
            background: white;
            overflow: hidden;
            box-shadow: 0.06rem 0.06rem 0.20rem #888888;
            p {
              padding: 0.2rem;
              &.fl {
                img.mark {
                  margin-left: 0.1rem;
                  width: 0.56rem;
                  position: relative;
                  top: 0.15rem;
                }
                span {
                  margin-left: 0.2rem;
                  font-family: '微软雅黑';
                  font-weight: 400;
                  font-style: normal;
                  font-size: 0.28rem;
                  color: rgba(0, 0, 0, 0.847058823529412);
                }
              }
              &.fr {
                margin-right: 0.15rem;
                display: flex;
                align-items: center;
                .switch {
                  margin-right: 0.2rem;
                  position: relative;
                  top: 0.03rem;
                }
                i.icon {
                  font-size: 0.56rem;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/groupDetail.vue